
import ReviewsViewLazyImage from '../LazyImage.vue';

export default {
  name: 'ReviewsViewSiteRatingsListItem',
  components: {
    ReviewsViewLazyImage,
  },
  props: {
    code: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    rating: {
      type: Number,
      required: true,
    },
    reviewCount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isImgLoaded: new Array(1).fill(false),
      imageUrl: '/skin/frontend/onestopbedrooms/default/images/review-icon',
    };
  },
  computed: {
    calcWidth() {
      return this.code === 'google' ? ((this.rating / 5) * 100 + 2) : ((this.rating / 5) * 100);
    },
    badgeImage() {
      const imageMap = {
        google: 'icon_sb_google',
        reseller_ratings: 'icon_sb_reseller',
        trust_pilot: 'icon_sb_trustpilot',
        site_jabber: 'icon_sb_sitejabber',
        shopper_approved: 'icon_sb_shopper',
        ekomi: 'icon_sb_ekomi',
        reviews_io: 'icon_sb_reviews',
      };
      const imageName = imageMap[this.code] || imageMap.google;

      return {
        src: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_logo_top_d.png`,
        alt: `${this.code} Review Logo`,
        sources: [
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_logo_top_m.png`,
            media: '(max-width: 767px)',
          },
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_logo_top_t.png`,
            media: '(min-width: 768px) and (max-width: 1199px)',
          },
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_logo_top_d.png`,
            media: '(min-width: 1200px)',
          },
        ],
      };
    },
    starImageSelected() {
      const imageMap = {
        google: 'icon_star_google',
        reseller_ratings: 'icon_star_reseller',
        trust_pilot: 'icon_star_trustpilot',
        site_jabber: 'icon_star_sitejabber',
        shopper_approved: 'icon_star_shopper',
        ekomi: 'icon_star_ekomi',
        reviews_io: 'icon_star_reviews',
      };
      const imageName = imageMap[this.code] || imageMap.google;

      return {
        src: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_selected_d.png`,
        alt: `${this.code} Review Logo`,
        sources: [
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_selected_t.png`,
            media: '(max-width: 767px)',
          },
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_selected_t.png`,
            media: '(min-width: 768px) and (max-width: 1199px)',
          },
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_selected_d.png`,
            media: '(min-width: 1200px)',
          },
        ],
      };
    },
    starImageUnselected() {
      const imageMap = {
        google: 'icon_star_google',
        reseller_ratings: 'icon_star_reseller',
        trust_pilot: 'icon_star_trustpilot',
        site_jabber: 'icon_star_sitejabber',
        shopper_approved: 'icon_star_shopper',
        ekomi: 'icon_star_ekomi',
        reviews_io: 'icon_star_reviews',
      };
      const imageName = imageMap[this.code] || imageMap.google;

      return {
        src: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_unselected_d.png`,
        alt: `${this.code} Review Logo`,
        sources: [
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_unselected_t.png`,
            media: '(max-width: 767px)',
          },
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_unselected_t.png`,
            media: '(min-width: 768px) and (max-width: 1199px)',
          },
          {
            srcset: `${this.$config.cdnBaseUrl}${this.imageUrl}/${imageName}_unselected_d.png`,
            media: '(min-width: 1200px)',
          },
        ],
      };
    },
  },
  methods: {
    removeLastDecimalDigit(number) {
      const numStr = number.toString();
      if (numStr.includes('.')) {
        const [integerPart, decimalPartTemp] = numStr.split('.');
        let decimalPart = decimalPartTemp;
        if (decimalPart.length === 2) {
          decimalPart = decimalPart.slice(0, 1);
        }
        return parseFloat(`${integerPart}.${decimalPart}`);
      }
      return number;
    },

    formatNumberWithCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    load(index) {
      this.$set(this.isImgLoaded, index, true);
    },
  },
};
